import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Archive icon. */
const ArchiveIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M17.3174 3.5C17.5934 3.50018 17.8174 3.72397 17.8174 4V7.33301C17.8174 7.60904 17.5934 7.83283 17.3174 7.83301H16.4834V16C16.4834 16.2761 16.2595 16.5 15.9834 16.5H3.9834C3.70741 16.4998 3.4834 16.276 3.4834 16V7.83301H2.65039C2.37425 7.83301 2.15039 7.60915 2.15039 7.33301V4C2.15039 3.72386 2.37425 3.5 2.65039 3.5H17.3174ZM4.4834 15.5H15.4834V7.83301H4.4834V15.5ZM11.3174 9.5C11.5934 9.50018 11.8174 9.72397 11.8174 10C11.8174 10.276 11.5934 10.4998 11.3174 10.5H8.65039C8.37425 10.5 8.15039 10.2761 8.15039 10C8.15039 9.72386 8.37425 9.5 8.65039 9.5H11.3174ZM3.15039 6.83301H16.8174V4.5H3.15039V6.83301Z" fill="currentColor" />
  </svg>
);

export default ArchiveIcon;
